import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthBridge } from '@core-features/bridge';
import { AuthUserInfoValue, IAuthService } from '@core-features/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthRemoteService implements IAuthService {
  private readonly _authBridge = inject(AuthBridge);

  isAuthenticated$: Observable<boolean> = this._authBridge.isAuthenticated$;
  $isAuthenticated: Signal<boolean> = toSignal(
    this._authBridge.isAuthenticated$,
    {
      initialValue: false,
    },
  );

  userInfo$: Observable<AuthUserInfoValue> = this._authBridge.userInfo$;
  $userInfo: Signal<AuthUserInfoValue> = toSignal(this.userInfo$);

  getAccessToken() {
    return this._authBridge.getAccessToken();
  }

  isAccessTokenValid() {
    return this._authBridge.isAccessTokenValid();
  }

  login(): void {
    this._authBridge.login();
  }

  logout(): void {
    this._authBridge.logout();
  }

  navigateToProfile(): void {
    this._authBridge.navigateToProfile();
  }

  logoutLocally(): void {
    this._authBridge.logoutLocally();
  }

  /**
   * The host owns the OIDC session, so a remote cannot trigger a silent
   * refresh itself. Fresh user info still reaches the remote: the host's
   * automatic silent refresh pushes new values through `AuthBridge.userInfo$`.
   * Returns `false` (no refresh initiated here). If a remote ever needs to
   * force a refresh, extend `AuthBridge`/`HostAdapter` to proxy this to the
   * host's `AuthHostService.refreshUserInfo()`.
   */
  refreshUserInfo(): Observable<boolean> {
    return of(false);
  }
}
